module.exports = require("deep-diff").default;
